<template>
  <div class="content">
    <div class="phone" v-if="step === 1">账号：{{ info.name ? info.name + '@' + info.domain.name : '-' }}</div>
    <a-form :form="form.fc" class="mt-4" autocomplete="off">
      <a-form-item v-if="step === 1">
        <a-input-group>
          <a-row :gutter="8">
            <a-col :span="14">
              <a-input v-decorator="decorators.sms_code" placeholder="验证码" />
            </a-col>
            <a-col :span="10">
              <a-button :disabled="enableSendSmsCode" @click="getWebSmsCode" style="width: 100%">{{ enableSendSmsCode ? '已发送(' + count + ')' : '获取验证码' }}</a-button>
            </a-col>
          </a-row>
        </a-input-group>
      </a-form-item>
      <a-form-item label="密码" v-bind="formItemLayout" v-if="this.step === 2">
        <a-input-password v-decorator="decorators.password" placeholder="新密码" />
      </a-form-item>
      <a-form-item label="确认密码" v-bind="formItemLayout" v-if="this.step === 2">
        <a-input-password v-decorator="decorators.com_password" placeholder="确认密码" />
      </a-form-item>
    </a-form>
    <a-button type="primary" @click="validatorSmsCode" v-if="step === 1">下一步</a-button>
    <a-button @click="goBack" class="mr-2" v-if="step === 2">上一步</a-button>
    <a-button type="primary" v-if="step === 2" @click="handleConfirm" :loading="loading">完成</a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'PhoneVerificationCode',
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      enableSendSmsCode: false,
      startCountDown: false,
      count: 60,
      timer: null,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        sms_code: [
          'sms_code',
          {
            rules: [
              { required: true, message: '请输入验证码' },
            ],
          },
        ],
        password: [
          'password',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请输入密码' },
              { validator: this.$validate('password') },
            ],
          },
        ],
        com_password: [
          'com_password',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '请再次确认密码' },
              { validator: this.checkComPassword },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
      code: '',
      step: 1,
      userId: '',
    }
  },
  computed: {
    ...mapState('auth', {
      info: state => state.info || {},
    }),
    ...mapState('app', {
      level: state => state.customerCapability.customer_level,
      customerId: state => state.customerCapability.customer_id,
    }),
  },
  watch: {
    startCountDown (val) {
      if (val) {
        this.clearTimer()
        this.timer = setInterval(() => {
          if (this.count !== 0) {
            this.count--
          } else {
            this.enableSendSmsCode = false
            this.startCountDown = false
          }
        }, 1000)
      }
    },
  },
  destroyed () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    getWebSmsCode () {
      this.createDialog('WebSmsCodeDialog', {
        account: this.info.name + '@' + this.info.domain.name,
        resource: 'resetcode',
        success: (responesData) => {
          this.userId = responesData.id
          this.enableSendSmsCode = true
          this.startCountDown = true
        },
      })
    },
    async validatorSmsCode () {
      const { sms_code: code } = await this.form.fc.validateFields()
      this.code = code
      this.step = 2
    },
    checkComPassword (rule, value, callback) {
      const password = this.form.fc.getFieldValue('password')
      if (password !== value) {
        callback(new Error('两次密码不统一'))
      }
      callback()
    },
    goBack () {
      this.step = 1
    },
    doResetPassword (data) {
      return this.$http.post('/v2/register/reset-password', data)
    },
    async handleConfirm () {
      this.loading = true
      try {
        const value = await this.form.fc.validateFields()
        if (!this.userId) {
          this.loading = false
          return this.$message.success('请获取验证码')
        }
        const params = {
          password: value.password,
          random_code: this.code,
          id: this.userId,
        }
        await this.doResetPassword(params)
        this.loading = false
        this.$bus.$emit('editPasswordSuccess')
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
  width: 350px;
  margin: 0 auto;
  .phone {
    font-size: 18px;
  }
}
</style>
